import React, { useState, useEffect } from 'react'
import { D3Pie } from '../../../../components'
import { GRAPH_COLOR_PALLET4, LEGEND_COLOR_MAP_NEW } from '../../../../constants'
import { CardInnerWrapper, LhsWrap, ListItemTextWrap, RhsWrap } from './style'

const RelativeBrands = ({ graphPieData, isExtraColor = false, showLegendToolTip = false }) => {
  // const colors =  isExtraColor ? Object.values(LEGEND_COLOR_MAP_NEW) : LEGEND_COLOR_MAP_NEW;
  const colors = GRAPH_COLOR_PALLET4
  const pieSettings = {
    width: 300,
    height: 300,
    cx: 40,
    cy: 40,
    outerRadius: 110,
    textShow: true,
    textLocation: 1.4,
    textSize: '14px',
    colors: colors,
    effects: 'InnerCircle',
    fontWeight: 300,
  }

  return (
    <CardInnerWrapper className='relativeBrands'>
      <LhsWrap>
        <D3Pie data={graphPieData} settings={pieSettings} showLegendToolTip={showLegendToolTip} />
      </LhsWrap>
      <RhsWrap>
        {graphPieData.map((leg, i) => {
          if (leg.name === 'REMAINING_VALUE') return false
          // if(leg.value === 0) return false
          const colorValue = Object.keys(LEGEND_COLOR_MAP_NEW).includes(leg.name)
            ? LEGEND_COLOR_MAP_NEW[leg.name]
            : colors[i]
          return (
            <ListItemTextWrap
              className={leg.value === 0 ? 'hide' : ''}
              key={i}
              primary={
                <>
                  <span style={{ backgroundColor: colorValue }}></span>
                  <b>{leg.value}%</b>
                </>
              }
              secondary={leg.name}
            />
          )
        })}
      </RhsWrap>
    </CardInnerWrapper>
  )
}

export default RelativeBrands
